import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Link } from 'react-router'
import Login from './Login'
import * as actions from '../actions/index'
import { loggedIn } from '../utils/utils'
import Breadcrumbs from 'react-breadcrumbs'
import { Button, Content, Drawer, Header, Icon, Layout, Navigation, ProgressBar, Snackbar } from 'react-mdl'

import { talkdesk } from '../utils/Talkdesk'

class Main extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object
  }

  componentWillMount() {
    talkdesk.refreshHeader()
  }

  // A hack to hide react-mdl Drawer on click inn a small screen
  // https://github.com/react-mdl/react-mdl/issues/254
  componentWillReceiveProps(nextProps) {
    // If our locations are different and drawer is open, force a close
    if (this.props.location.pathname !== nextProps.location.pathname) {
      const l = document.querySelector('.mdl-js-layout');
      const d = document.querySelector('.mdl-layout__drawer');
      if (l && l.classList && d && d.classList && l.classList.contains('is-small-screen') && d.classList.contains('is-visible')) {
        l.MaterialLayout.toggleDrawer();
      }
    }
  }

  goToURL(url) {
    this.context.router.push(url);
  }

  renderBreadcrumbs() {
    const { breadcrumbsRouteTitles, appId, channelType, params, routes } = this.props

    for (var x = 0 ; x<routes.length ; x++) {
      const obj = routes[x]
      if (obj.path === ":app") {
        const title = breadcrumbsRouteTitles.app ? breadcrumbsRouteTitles.app[appId] : undefined
        obj.name = title ? title : appId
      }
      else if (obj.path === "channels/:channel") {
        const title = breadcrumbsRouteTitles.channel ? breadcrumbsRouteTitles.channel[channelType] : undefined
        obj.name = title ? title : channelType
      }
    }

    return (
      <Breadcrumbs
          routes={routes}
          params={params}
          excludes={['Main', 'Overview']}
          separator={<Icon name='chevron_right'/>}
      />
    )
  }

  renderTopbarButtons() {
    return (
      <div style={{position: 'absolute', right: '10px'}}>
        {
          this.props.topbarButtons.map((button, index) => (
            <Button key={index} onClick={()=>button.action()} style={{color: "#fff"}}>
              <Icon name={button.icon} /> {button.title}
            </Button>
          ), this)
        }
      </div>
    )
  }


  handleTimeoutSnackbar = () => {
    this.props.dispatch(actions.setMessage(null))
  };

  render() {

    if ( this.props.location.pathname.split("/")[1].toLowerCase() === "talkdesk" ) {
      let children = null;
      if (this.props.children) {
        children = React.cloneElement(this.props.children, {
                                      dispatch: this.props.dispatch,
                                      })
      }

      return (
        <div>
          {children}
        </div>
      )
    }

    if (!loggedIn()) {
      return (
        //setting the location param to know if the login is happening already
        <Login location={this.props.location}/>
      )
    }

    let children = null;
    if (this.props.children) {
      const { appId, channelType, dispatch } = this.props
      children = React.cloneElement(this.props.children, {
        appId: appId, //used in AppPage to fetch app
        channelType: channelType, //used in ChannelPage
        adminBaseUrl: this.props.adminBaseUrl,
        ahBaseUrl: this.props.ahBaseUrl,
        dispatch: dispatch,
      })
    }

    const {snackbarMessage} = this.props

    let loading = null;
    if (this.props.loading) {
      loading = <ProgressBar indeterminate style={{width:"100%"}}/>
    }
    else {
      loading = <ProgressBar progress={100} style={{visibility: "hidden"}}/>
    }

    return (
      <Layout fixedHeader fixedDrawer>
        <Header title={this.renderBreadcrumbs()}>
          {this.renderTopbarButtons()}
        </Header>
            {loading}
        <Drawer title="AssistHub">
          <Navigation>
            <Link to="/apps">Brands</Link>
            <Link to="/account">Account</Link>
            <Link to="/support">Support</Link>
          </Navigation>
        </Drawer>
        <Content style={{paddingLeft: 15, paddingRight: 15}}>
          {children}
          <Snackbar active={snackbarMessage !== null} onTimeout={this.handleTimeoutSnackbar} timeout={2750}>
            {snackbarMessage}
          </Snackbar>
        </Content>
      </Layout>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  adminBaseUrl: state.adminBaseUrl,
  ahBaseUrl: state.ahBaseUrl,
  appId: ownProps.params.app,
  channelType: ownProps.params.channel,
  snackbarMessage: state.message,
  loading: state.loading,
  topbarButtons: state.topbarButtons,
  breadcrumbsRouteTitles: state.breadcrumbsRouteTitles
})

export default connect(mapStateToProps)(Main)



// WEBPACK FOOTER //
// ./src/containers/Main.js